import type { CancelPolicyApiComponentBlock } from "../types";

export type ResolvedComponent = { id: string; data: unknown };

export const hasComponentMapping = (
  component: CancelPolicyApiComponentBlock | undefined,
  mapping: Record<string, unknown>
): component is ResolvedComponent =>
  Boolean(component?.id && mapping[component.id]);
